import { render, staticRenderFns } from "./EventContent.vue?vue&type=template&id=47848bc0&scoped=true"
import script from "./EventContent.vue?vue&type=script&lang=js"
export * from "./EventContent.vue?vue&type=script&lang=js"
import style0 from "./EventContent.vue?vue&type=style&index=0&id=47848bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47848bc0",
  null
  
)

export default component.exports